import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { calTotal } from "../../../../../utils/giftshop";
import { useFormik } from "formik";
import { createValidationSchema } from "../../../../../utils/validatorSchema";
import { sendMailApi } from "../../../../../services/payment";
import { toast } from "react-toastify";
import { ICartData } from "../../../../../store/giftshop/type";
import { GiftType, PROMO_TYPE } from "../../../../../models/giftcard";
import moment from "moment";
import "./confirmation.scss";
import { IMAGE_URL_CONFIG } from "../../../../../constants/url";
import Button from "../../../../../components/UI/Button";
import { addGiftCart } from "../../../../../store/giftshop/action";

export interface GiftshopConfirmationProps {
  onCloseModal: () => void;
}

const GiftshopConfirmation: FC<GiftshopConfirmationProps> = ({
  onCloseModal,
}) => {
  const { countryId, cart, bookingId, orderResponse, modal } = useSelector(
    (state: RootState) => ({
      cart: state.giftCardReducer.cart,
      bookingId: state.giftCardReducer.bookingId,
      orderResponse: state.giftCardReducer.orderResponse,
      countryId: state.applicationReducer.countryId,
      modal: state.ticketBookingReducer.modal
    })
  );

  const [cartData, setCartData] = useState<{
    deliveryFee: number;
    deliveryQty: number;
    total: number;
    shippingAddress: Array<any>;
  }>({ deliveryFee: 0, deliveryQty: 0, total: 0, shippingAddress:[] });

  const [purchasedCards, setPurchasedCards] = useState<ICartData[]>([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (cart && countryId) {
      setCartData(calTotal(cart, countryId));
    }
    let mappedData = [...cart];
    if(modal?.data?.giftcardDetails){
      const giftcardDetails = modal.data.giftcardDetails;
      mappedData = cart.map((v:ICartData)=>{
        const expiration: any = giftcardDetails.find((g: any)=>g.uuid === v.uuid);
        return {
          ...v,
          expiration: expiration?.cardDetais?.length > 0?expiration.cardDetais[0]?.cardExpiryDate:''
        }
      })
    }
    setPurchasedCards([...mappedData]);
    dispatch(addGiftCart([]));
  }, []);

  const { handleSubmit, values} =
    useFormik({
      validationSchema: createValidationSchema("sendReceipt"),
      enableReinitialize: true,
      initialValues: {
        email: modal?.data?.email,
      },
      onSubmit: async (values) => {
        const payload = {
          id: orderResponse?.userSessionId!,
          countryId: countryId,
          templateName: "Giftcard order confirmation",
          email: modal?.data?.email,
        };
        const { status, error }: any = await sendMailApi(payload);
        if (status) {
          toast.success("Mail sent successfully");
        } else {
          toast.error(error || "Something went wrong");
        }
      },
    });

  return (
    <div>
      <div className="modal-giftcard-thankspg">
        <div className="modal-purchase-code">
          <div className="purchase-code-left">
            <div className="reference-wrapper">
              <p className="reference-text">PURCHASE REFERENCE ID</p>
              <p className="reference-number">{bookingId}</p>
            </div>
          </div>
        </div>
        <div className="send_sec_main">
           <div className="send_sec">
              <h2>
                <img
                  src={`${IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH}success-Selected.png`}
                  alt=""
                />{" "}
                Receipt Sent!
              </h2>
              <p className="email-to">
                <span>Emailed To:&nbsp;</span>{modal?.data?.email}
              </p>
              <div className="btn-section">
                <Button classNames="m-r-10" onClick={handleSubmit} text="Resend" type="outline" />
              </div>
            </div>
        </div>
        <div className="note-wrapper">
          <p className="notes">
            <span>Please check your spam or junk folder </span>  
            if you don’t see your purchase receipt in your inbox. You’ll also receive email confirmations for any gift cards scheduled or sent.
          </p>
        </div>
        <div className="purchase-details-wrapper">
          <div className="purchase-details-main">
            {purchasedCards &&
              purchasedCards.length > 0 &&
              purchasedCards.map((item: ICartData) => (
                <div className="purchase-details-sec">
                  <p className="purchased-card-header">
                    {item?.promo ? "$"+item?.promo?.amount+" Bonus" : item.description}{" "}
                  </p>
                  {item.giftcardType == GiftType.ecard ? (
                    <p>
                      <span>Gift Type:&nbsp;</span>E-Gift Card
                    </p>
                  ) : item.giftcardType == GiftType.physical ? (
                    <p>
                      <span>Gift Type:&nbsp;</span>Physical Gift Card
                    </p>
                  ) : null}
                  {/* item.giftcardType == GiftType.exp ? (
                    <p>
                      <span>Gift Type:</span> Experience
                    </p>
                  ) : null} */}
                  <p>
                    <span>Gift To:&nbsp;</span>{item.recipientName}
                  </p>
                  {item.giftcardType == GiftType.ecard ? (
                    <p>
                      <span>Deliver To:&nbsp;&nbsp;</span>{item.recipientemail}
                    </p>
                  ) : null}
                  {item.giftcardType !== GiftType.ecard ? (
                    <p>
                      <span>Deliver To:&nbsp;&nbsp;</span> {item.address1} {item.address2}, {item.city}, {item.state} {item.postCode}
                    </p>
                  ) : null}
                  {item.giftcardType == GiftType.ecard ? (
                    <p>
                      <span>Delivery Date:&nbsp;</span>
                      {moment(item.deliveryDate).format("MMM DD, YYYY")}
                    </p>
                  ) : null}
                  <p>
                    <span>From:&nbsp;</span>{item.senderName}
                  </p>
                  <p>
                    <span>Message:&nbsp;</span>{item.giftMessage}
                  </p>
                  <p>
                    <span>Quantity:&nbsp;</span>{item.quantity}
                  </p>
                  {item?.promoType === PROMO_TYPE.SEPARATE ? (
                    <p></p>
                  ) : (
                    <p>
                      <span>Item Total:&nbsp;</span>$ {item.itemTotal.toFixed(2)}
                    </p>
                  )}
                  <p>
                    <span>Expires On:&nbsp;</span>{item.expiration?moment(item.expiration,'MM/DD/YYYY').format('DD MMM YYYY'):'(No Expiration)'}
                  </p>
                </div>
              ))}
          </div>
          {cartData.shippingAddress.length > 0?
          <div className="cart-detail-delivery">
          {/* <h4>${cartData.deliveryFee.toFixed(2)} Delivery Fee</h4> */}
          <ul>
            {cartData.shippingAddress.map((item: any, index: any) => {
              return (
                <div className="shipping-details">
                  <p className="delivery-details">
                    $ {Number(item.shippingDetails.shippingFee).toFixed(2)}
                    {item.shippingDetails.name}
                  </p>
                  <li id="cart" className="m-0" key={index}>
                    <p className="deliver-to">
                      Deliver To:&nbsp;&nbsp;
                      <span> {item.address1} {item.address2}, {item.city}, {item.state} {item.postCode} </span>
                    </p>
                  </li>
                </div>
              );
            })}
          </ul>
        </div>
           : null}
          <div className="delivery_fee_det">
            <p className="total-label">Total Purchase</p>
            <p className="total-amt">$ {cartData.total.toFixed(2)}</p>
          </div>
        </div>
        {/* <div className="send_sec_main">
          {isMailSent ? (
            <div className="send_sec">
              <h2>
                <img
                  src={`${IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH}success-Selected.png`}
                  alt=""
                />{" "}
                Receipt Sent!
              </h2>
              <p className="email-to">
                <span>Emailed To&nbsp;</span>{values.email}
              </p>
              <div className="btn-section">
                <Button classNames="m-r-10" onClick={handleSubmit} text="Resend" type="fill" />
              </div>
            </div>
          ) : (
            <div className="sent_receipt">
              <h3>Send digital confirmation to your email</h3>
              <div className="sent_receipt_maingrp">
                <div className="form-group m-r-10">
                  <label>Email To</label>
                  <div className="email-parent-close">
                    <TextInput
                      value={values.email}
                      field={"email"}
                      handleChange={handleChange}
                      touched={touched.email!}
                      error={errors.email}
                    />

                    <img src="closeIcon" alt="" />
                  </div>
                </div>
                <div className="btn-section m-0 ">
                  <Button iconWidth={15} iconHeight={15} onClick={handleSubmit} text= "Send receipt" type="fill" iconPosition = "pre" icon={`${IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH}envelope-white.png`} />
                </div>
              </div>
            </div>
          )}
        </div> */}
      </div>

      <div className="row btn-section thanks_modal_btnsec gift-confirm-footer-btn">
        <div className="col-md-12 movie_footer_btn_el ml-auto">
          <div className="movie_button_wrap d-flex justify-content-end">
            <Button text="Return To Gift Shop Home" type="fill" onClick={onCloseModal} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftshopConfirmation;
